import domReady from '@wordpress/dom-ready';
import { prevArrow, nextArrow } from '../util';

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  const $ = jQuery.noConflict();

  /* Block scripts */
  if ( document.querySelector('.slideshow') ) {
    document.querySelectorAll('.slideshow').forEach(block => {
      const slider = $(block).find('.slideshow__inner-blocks');
      const slides = $(block).find('.slideshow-slide');
      const captionSlider = $(block).find('.slideshow__captions');
      const arrowsContainer = $(block).find('.slideshow__arrows');
      const nums = $(block).find('.slideshow__nums');
      const cur = nums.find('.current');
      const total = nums.find('.total');
      const slideCount = slides.length;
      total.text(slideCount < 10 ? `0${slideCount}` : slideCount);

      const removeRegion = function() {
        $(this).get(0).removeAttribute('aria-label');
        $(this).get(0).removeAttribute('role');
        block.setAttribute('aria-label', 'Image Slideshow');
        block.setAttribute('role', 'region');
      };

      slider.on('init', removeRegion);
      captionSlider.on('init', removeRegion);

      slides.each(function(){
        const img = this.querySelector('img');
        if ( img ) {
          const isPortrait = parseInt(img.getAttribute('width')) < parseInt(img.getAttribute('height'));
          if (isPortrait) {
            $(this).addClass('portrait');
            const clone = img.cloneNode(true);
            clone.classList.add('slideshow-slide-clone');
            $(this).append(clone);
          }
        }

        const caption = $(this).find('.wp-element-caption');
        if ( caption.length > 0 ) {
          captionSlider.append(caption);
        } else {
          captionSlider.append('<div class="slideshow__caption-placeholder"></div>');
        }
      });

      $(slider).slick({
        asNavFor: captionSlider,
        prevArrow,
        nextArrow,
        appendArrows: arrowsContainer,
        adaptiveHeight: true
      });

      $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        cur.text(nextSlide < 9 ? `0${nextSlide + 1}` : nextSlide + 1);
      });

      $(captionSlider).slick({
        asNavFor: slider,
        arrows: false,
        fade: true,
        adaptiveHeight: true
      });
    });
  }
});